import { FormData, MimeType } from "@graffer-inc/form-schema";
import { BaseEntity } from "../base/base-entity";

export type SurveyAnswerType = {
  id: string;
  answer: FormData;
  files: SurveyAttachedFile[];
};

export class SurveyAnswer extends BaseEntity {
  id: string;

  answer: FormData;

  files: SurveyAttachedFile[];

  constructor(values: SurveyAnswerType) {
    super();
    this.id = values.id;
    this.answer = values.answer;
    this.files = values.files;
  }

  static fromJSON(values: SurveyAnswerType) {
    return new SurveyAnswer(values);
  }
}

export type SurveyAttachedFile = {
  type: MimeType;
  size: number;
  path: string;
  refKey: string;
  name: string;
};
